import * as utils from './utils'
import { BaseObject } from './_baseClasses'

const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

export interface QuestionSet {
  category: string,
  questions: Question[]
}

export class Question extends BaseObject {

  // simple, non-class fields
  public id: string = null
  public category: string = null
  public text: string = null
  public universal: boolean = null
  public difficulty: number = null
  public dateIntoServiceMS: number = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, id?: string, category?: string, text?: string, universal?: boolean, difficulty?: number) {
    super()
    if (po) this.injectPlainObject(po)
    if (id != null) this.id = id
    if (category != null) this.category = category
    if (text != null) this.text = text
    if (universal != null) this.universal = universal
    if (difficulty != null) this.difficulty = difficulty

    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

}




(async () => {
})();
